import { Route, Routes, Navigate } from 'react-router-dom';
import { nombreProductoActivo } from './lib/brandingDelProducto.js';
import { LoginPage } from './routes/LoginPage.js';
import { VerificarAccesoPage } from './routes/VerificarAccesoPage.js';
import { DashboardPage } from './routes/DashboardPage.js';
import { ProjectsPage } from './routes/ProjectsPage.js';
import { ProjectWorkspacePage } from './routes/ProjectWorkspacePage.js';
import { QuotePage } from './routes/QuotePage.js';
import { CustomDbsPage } from './routes/CustomDbsPage.js';
import { PlanosPage } from './routes/PlanosPage.js';
import { TiposRecordadosPage } from './routes/TiposRecordadosPage.js';
import { DemosPage, DemoPage } from './routes/demos/DemosPage.js';
import { FilesPage } from './routes/FilesPage.js';
import { CatalogsPage } from './routes/CatalogsPage.js';
import { CatalogDetailPage } from './routes/CatalogDetailPage.js';
import { SettingsMembersPage } from './routes/SettingsMembersPage.js';
import { StaffUsagePage } from './routes/StaffUsagePage.js';
import { StaffRunsUsagePage } from './routes/StaffRunsUsagePage.js';
import { StaffTenantUsagePage } from './routes/StaffTenantUsagePage.js';
import { StaffUserUsagePage } from './routes/StaffUserUsagePage.js';
import { StaffApuLibraryPage } from './routes/StaffApuLibraryPage.js';
import { StaffCalibracionPage } from './routes/StaffCalibracionPage.js';
import { StaffPreciosPage } from './routes/StaffPreciosPage.js';
import { StaffSesionesActivasPage } from './routes/StaffSesionesActivasPage.js';
import { StaffImportacionesPage } from './routes/StaffImportacionesPage.js';
import { StaffActividadPage } from './routes/StaffActividadPage.js';
import { StaffActividadUsuarioPage } from './routes/StaffActividadUsuarioPage.js';
import { StaffContextHelpPage } from './routes/StaffContextHelpPage.js';
import { StaffActividadCiPage } from './routes/StaffActividadCiPage.js';
import { AdlicSimPage } from './routes/AdlicSimPage.js';
import { ObraContextPage } from './routes/ObraContextPage.js';
import { QuoteApuIaRunPage } from './routes/QuoteApuIaRunPage.js';
import { QuoteApuIaPrintPage } from './routes/QuoteApuIaPrintPage.js';
import { PlanoApuPrintPage } from './routes/PlanoApuPrintPage.js';
import { ProtectedRoute } from './components/ProtectedRoute.js';
import { AuthBootstrap } from './components/AuthBootstrap.js';
import { SubscriptionInactiveGate } from './components/SubscriptionInactiveGate.js';
import { QuotaExceededListener } from './components/QuotaExceededListener.js';
import { QaSubscriptionModeGate } from './components/QaSubscriptionModeGate.js';
import { QuoteJobsWatcher } from './components/TrabajosEnCurso.js';
import { VigilanteDeVersion } from './components/VigilanteDeVersion.js';

export function App() {
  return (
    <AuthBootstrap>
      {/* Mantiene la pestaña en la version que esta servida. Va DENTRO del Router
          porque una de las dos ocasiones en que se permite recargar es al navegar
          (la otra es al volver a la pestaña); ver el comentario del componente. */}
      <VigilanteDeVersion />
      <SubscriptionInactiveGate />
      <QuotaExceededListener />
      <QaSubscriptionModeGate />
      {/* Mantiene vivo el WS del proyecto con cotización corriendo aunque el
          usuario navegue — es lo que alimenta el avance que se ve al volver
          al presupuesto. */}
      <QuoteJobsWatcher />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* Segundo paso de la entrada: el código que llegó por correo (equipo nuevo / staff). */}
        <Route path="/verificar-acceso" element={<VerificarAccesoPage />} />
        {/* `/status` era el andamio de la fase 0: decía "v0.0.1 · fase 0 — bootstrap",
            tenía dos botones muertos y le mostraba a cualquiera el estado de Postgres,
            Redis y MinIO por nombre. Es una URL pública, así que sale de circulación.
            Para monitoreo están `/health` y `/ready` del API. El componente
            (`routes/LandingPage.tsx`) queda en el repo como punto de partida si algún
            día hay una portada de verdad. */}
        <Route path="/status" element={<Navigate to="/login" replace />} />

        <Route
          path="/"
          element={
            <ProtectedRoute requireProgram="supernova">
              <Navigate to="/projects" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <ProtectedRoute requireProgram="supernova">
              <ProjectsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/:id"
          element={
            <ProtectedRoute requireProgram="supernova">
              <ProjectWorkspacePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/:id/quotes/:qid"
          element={
            <ProtectedRoute requireProgram="supernova">
              <QuotePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/:id/obra-context"
          element={
            <ProtectedRoute requireProgram="supernova">
              <ObraContextPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/:id/quotes/:qid/apu-ia"
          element={
            <ProtectedRoute requireProgram="supernova">
              <QuoteApuIaRunPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/:id/quotes/:qid/apu-ia/runs/:runId"
          element={
            <ProtectedRoute requireProgram="supernova">
              <QuoteApuIaRunPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/:id/quotes/:qid/apu-ia/runs/:runId/print"
          element={
            <ProtectedRoute requireProgram="supernova">
              <QuoteApuIaPrintPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/custom-dbs"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal>
              <CustomDbsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/files"
          element={
            <ProtectedRoute requireProgram="supernova">
              <FilesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalogs"
          element={
            <ProtectedRoute requireProgram="supernova">
              <CatalogsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalogs/:id"
          element={
            <ProtectedRoute requireProgram="supernova">
              <CatalogDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/members"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal>
              <SettingsMembersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff/usage"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffUsagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff/usage/runs"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffRunsUsagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff/usage/tenants/:tenantId"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffTenantUsagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff/usage/tenants/:tenantId/users/:userId"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffUserUsagePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff/apu-library"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffApuLibraryPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff/calibracion"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffCalibracionPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff/precios"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffPreciosPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff/sesiones-activas"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffSesionesActivasPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff/importaciones"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffImportacionesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff/actividad"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffActividadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff/actividad/:userId"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffActividadUsuarioPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff/actividad-ci"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffActividadCiPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff/context-help"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <StaffContextHelpPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff/adlic-sim"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <AdlicSimPage />
            </ProtectedRoute>
          }
        />

        {/* Lectura de planos (WIP, DWG/DXF → HP). Oculta: gated por el flag del front
            `VITE_PLANO_A_HP_ENABLED` (en prod va vacío) + STAFF Ecosoft (`soloStaff`).
            El backend además devuelve 404 con `PLANO_A_HP_ENABLED` apagado y exige
            `requireStaff()` en todas sus rutas. */}
        <Route
          path="/planos"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <PlanosPage />
            </ProtectedRoute>
          }
        />
        {/* «Conceptos asignados»: lo que la empresa recuerda de sus planos (mismo gate; la ruta se apaga con MEMORIA_TIPOS_ENABLED). */}
        <Route
          path="/planos/tipos-recordados"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <TiposRecordadosPage />
            </ProtectedRoute>
          }
        />
        {/* Misma pantalla entrando DESDE el proyecto (ci): el proyecto viene de la ruta y
            no hay combo para elegirlo. */}
        <Route
          path="/project/:id/planos"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <PlanosPage />
            </ProtectedRoute>
          }
        />
        {/* Un plano abierto (se abre solo): la tira de arriba cambia entre planos del proyecto. */}
        <Route
          path="/project/:id/planos/:fileId"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <PlanosPage />
            </ProtectedRoute>
          }
        />

        {/* Impresión de los análisis con IA de la hoja de un plano (pestaña nueva). */}
        <Route
          path="/project/:id/planos/:fileId/analisis/imprimir"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <PlanoApuPrintPage />
            </ProtectedRoute>
          }
        />

        {/* Demos de funciones futuras de OPUS ci: solo ci (la página lo revisa) + staff Ecosoft. */}
        <Route
          path="/demos"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <DemosPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/demos/:demoId"
          element={
            <ProtectedRoute requireProgram="supernova" soloUsuarioReal soloStaff>
              <DemoPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/no-access"
          element={
            <div style={{ padding: 48, textAlign: 'center', color: 'var(--text-secondary)' }}>
              Tu organización no tiene contratado {nombreProductoActivo()}.
            </div>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthBootstrap>
  );
}
